module.exports = {
  emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  //   passwordRegex: /^(?=.*[A-Z])(?=.*\d).{9,}$/,
  // phoneNoRegex: /^\d{9,}$/,
};
